module.exports = __webpack_public_path__ + "static/media/img-heritage-area2-shuseikan03.bac4fbb6.jpg";